module.exports = __webpack_public_path__ + "static/media/square-green.20dd7166.svg";